import React from 'react';
import {
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from '@mui/material';

import {
  MORTGAGES,
  MORTGAGES_DROPDOWN_OPTIONS,
} from '../../constants/Dashboard/Financing/mortgage';

import './LoanTermTabs.css';
import './MortgagesDropdown.css';

export const MortgagesDropdown = ({ handleMortgageTermsChange, mortgageTerm }) => {
  return (
    <div className="mortgage-dropdown-wrapper">
      <InputLabel id="home-financing-input-label">{MORTGAGES}</InputLabel>
      <FormControl sx={{ width: '100%', maxWidth: 420 }}>
        <Select
          sx={{ m: 1, ml: 0, width: '97.5%' }}
          id="financing-select-helper"
          multiple
          value={mortgageTerm}
          onChange={(e) => {
            handleMortgageTermsChange(e.target.value);
          }}
          input={<OutlinedInput label="30" />}
          renderValue={(selected) => selected.join(', ')}
        >
          {MORTGAGES_DROPDOWN_OPTIONS.map(({ title, value }) => (
            <MenuItem key={value} value={value}>
              <Checkbox checked={mortgageTerm.includes(value)} />
              <ListItemText primary={title} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};
